import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs'; 

@Injectable()
export class DownloadService {

  constructor(
    private _http: HttpClient
  ) {}

  public getDownloadInfo(course_id: string): Observable<any>{
    return this._http.get(environment.assetManagerUrl + '/download/' + course_id + '/link');
  }
  public downloadBundle(course_id: string): Observable<any>{
    return this._http.get(environment.assetManagerUrl + '/download/' + course_id + '/init');
  }
}
